var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("z-message-notice " + _vm.activeClass)},[_c('div',{staticClass:"z-message-notice-content"},[_c('i',{class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }